import {
    INVENTORY_HISTORY_DATA,
    INVENTORY_HISTORY_ERROR,
    INVENTORY_HISTORY_LOADING,
    INVENTORY_HISTORY_PAGE_CHANGE,
    INVENTORY_HISTORY_STATE_CHANGE,
} from "../constants";
import { authExpire } from "../../auth/actions";
import { makePrivateApiCall } from "utilities/dist/api";
import { parseAmount, parseServerTimestampForClient } from "../../common/helpers";
import { buildInvoiceNumberWithBeer } from "utilities/dist/invoice/helpers";
import { format } from "date-fns";
import { DateFormat } from "utilities/dist/invoice/constants";

export const loadInventoryHistoryPage = (state, grid) => dispatch => {
    let { lastRow, sortModel, filterModel } = state;

    dispatch({
        type: INVENTORY_HISTORY_LOADING,
    });

    const params = {
        endRow: grid.endRow,
        filterModel,
        sortModel,
        startRow: grid.startRow,
    };

    return makePrivateApiCall({
        url: "/inventory/history/grid",
        method: "get",
        params,
    })
        .then(res => {
            if (res.data) {
                const inventories = res.data.rows;
                lastRow = res.data.count;

                grid.successCallback(inventories, lastRow);

                dispatch({
                    type: INVENTORY_HISTORY_DATA,
                    payload: { inventories, lastRow },
                });
            }
        })
        .catch(err => {
            grid.failCallback(err);

            if (err.response && err.response.status === 401) {
                return dispatch(authExpire());
            }

            dispatch({
                type: INVENTORY_HISTORY_ERROR,
                payload: err.message,
            });
        });
};

export const changeInventoryHistoryPage = page => {
    return {
        type: INVENTORY_HISTORY_PAGE_CHANGE,
        payload: page,
    };
};

export const changeInventoryHistoryState = gridState => dispatch =>
    dispatch({
        type: INVENTORY_HISTORY_STATE_CHANGE,
        payload: gridState,
    });

const formatInventoryHistoryForExport = inventoryRow => {
    const row = {
        Distributor: inventoryRow.inventory.distributor,
        UPC: inventoryRow.inventory.product.upc,
        Product: inventoryRow.inventory.product.product,
        Size: inventoryRow.inventory.product.product_size,
        "Unit Price": parseAmount(inventoryRow.inventory.product.product_price),
        Qty: inventoryRow.qty,
        Source: inventoryRow.source,
        Ref: inventoryRow.invoice_id
            ? buildInvoiceNumberWithBeer(inventoryRow.invoice)
            : inventoryRow.ref,
        Date: format(parseServerTimestampForClient(inventoryRow.created_at), DateFormat),
    };

    return row;
};

export const exportInventoryHistory = state => () => {
    let { sortModel, filterModel } = state;

    const params = {
        filterModel,
        sortModel,
        ignoreLimit: true,
    };

    return makePrivateApiCall({
        url: "/inventory/history/grid",
        method: "get",
        params,
    }).then(res => {
        if (res.data) {
            return res.data.rows.map(formatInventoryHistoryForExport);
        }

        throw new Error("No inventory found");
    });
};
